import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import Scrollbar from 'src/components/scrollbar';

export default function SectionLayout({
  section,
  heading,
  subHeading,
  owner,
  admin,
  jobCreator,
  contactPerson,
  interviewScheduler,
  handleChange,
  users,
}) {
  const items = {
    interviewScheduler: {
      title: 'Interview Scheduler',
      value: interviewScheduler,
    },
    jobCreator: {
      title: 'Job Creator',
      value: jobCreator,
    },
    owner: {
      title: 'Owner',
      value: owner,
    },
    admin: {
      title: 'Admin',
      value: admin,
    },
    contactPerson: {
      title: 'Single Point of Contact',
      value: contactPerson,
    },
  };

  return (
    <Accordion>
      <AccordionSummary>
        <Stack spacing="8px">
          <Typography variant="subheading2">{heading}</Typography>
          <Typography variant="input" color="content.primaryBlack3">
            {subHeading}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing="16px">
          {Object.keys(items)
            .filter(
              filter =>
                items[filter].value !== null &&
                items[filter].value !== undefined,
            )
            .map((item, index) => (
              <Fragment key={index}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography variant="paragraph">
                    {items[item].title}
                  </Typography>
                  {item === 'contactPerson' ? (
                    users &&
                    users.length > 0 && (
                      <FormControl>
                        <Select
                          value={items[item].value?.id || 'Assign To'}
                          onChange={e => {
                            handleChange(section, item, 'id', e.target.value);
                          }}
                          renderValue={value => {
                            const selectedUser = users.find(
                              user => user.id === value,
                            );
                            return selectedUser?.name || selectedUser?.email;
                          }}
                          sx={{
                            '& .MuiOutlinedInput-input': {
                              minWidth: '100px',
                              maxWidth: '100px',
                            },
                            bgcolor: 'background.primaryGrey1',
                            maxHeight: '200px',
                          }}
                        >
                          {/* <Scrollbar
                            sx={{
                              maxHeight: '200px',
                              width: '300px',
                            }}
                          > */}
                          {users.map(user => (
                            <MenuItem key={user.id} value={user.id}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                              >
                                <Typography
                                  variant="caption"
                                  color="content.primaryBlack2"
                                  textAlign="left"
                                  sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '180px',
                                  }}
                                >
                                  {user.name || '-'}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="content.primaryBlack2"
                                  textAlign="right"
                                  sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '180px',
                                  }}
                                >
                                  {user.email}
                                </Typography>
                              </Stack>
                            </MenuItem>
                          ))}
                          {/* </Scrollbar> */}
                        </Select>
                      </FormControl>
                    )
                  ) : (
                    <Switch
                      checked={items[item].value.enabled}
                      onChange={event => {
                        handleChange(
                          section,
                          item,
                          'enabled',
                          event.target.checked,
                        );
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  )}
                </Stack>
                {index <
                  Object.keys(items).filter(
                    filter =>
                      items[filter].value !== null &&
                      items[filter].value !== undefined,
                  ).length -
                    1 && <Divider />}
              </Fragment>
            ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}

SectionLayout.propTypes = {
  section: PropTypes.oneOf([
    'dailyReport',
    'candidateCommunication',
    'calenderRequest',
  ]).isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  owner: PropTypes.object,
  admin: PropTypes.object,
  jobCreator: PropTypes.object,
  contactPerson: PropTypes.object,
  interviewScheduler: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  users: PropTypes.array,
};
